// Touch scroll functionality for variant pickers
document.addEventListener('DOMContentLoaded', function() {
  initializeTouchScroll();
});

// Also handle dynamic updates
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      initializeTouchScroll();
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

function initializeTouchScroll() {
  const touchScrollElements = document.querySelectorAll('.touch-scroll:not(.touch-scroll-initialized)');
  
  touchScrollElements.forEach(function(element) {
    // Mark as initialized to prevent double initialization
    element.classList.add('touch-scroll-initialized');
    
    // Check if already wrapped
    if (element.querySelector('.scroll-wrapper')) {
      return;
    }
    
    // Create a wrapper for the scrollable content
    const scrollWrapper = document.createElement('div');
    scrollWrapper.className = 'scroll-wrapper';
    scrollWrapper.style.cssText = `
      position: relative !important;
      width: 100% !important;
      overflow: hidden !important;
      margin: 0 !important;
      padding: 0 !important;
    `;
    
    // Create an inner container for the scrollable content
    const scrollContainer = document.createElement('div');
    scrollContainer.className = 'scroll-container';
    scrollContainer.style.cssText = `
      display: flex !important;
      overflow-x: auto !important;
      overflow-y: hidden !important;
      -webkit-overflow-scrolling: touch !important;
      scrollbar-width: none !important;
      -ms-overflow-style: none !important;
      padding: 0 !important;
      margin: 0 !important;
      width: 100% !important;
      box-sizing: border-box !important;
      position: relative !important;
      z-index: 1 !important;
    `;
    
    // Move the existing content into the scroll container
    while (element.firstChild) {
      scrollContainer.appendChild(element.firstChild);
    }
    
    // Create the fade overlay
    const fadeOverlay = document.createElement('div');
    fadeOverlay.className = 'fade-overlay';
    fadeOverlay.style.cssText = `
      position: absolute !important;
      top: 0 !important;
      right: 0 !important;
      bottom: 0 !important;
      width: 80px !important;
      pointer-events: none !important;
      background: linear-gradient(to right, 
        rgba(var(--color-background), 0) 0%,
        rgba(var(--color-background), 0.5) 40%,
        rgba(var(--color-background), 1) 100%
      ) !important;
      z-index: 0 !important;
    `;
    
    // Assemble the structure
    scrollWrapper.appendChild(scrollContainer);
    scrollWrapper.appendChild(fadeOverlay);
    element.appendChild(scrollWrapper);

    // Initialize scroll handling
    let isScrolling = false;
    let startX = 0;
    let scrollLeft = 0;
    let startTime = 0;
    let initialX = 0;
    const clickThreshold = 3; // Reduced threshold for better click detection
    let clicksDisabled = false;

    function enableClicks() {
      if (clicksDisabled) {
        scrollContainer.querySelectorAll('label, input[type="radio"]').forEach(el => {
          el.style.pointerEvents = '';
        });
        clicksDisabled = false;
      }
    }

    function disableClicks() {
      if (!clicksDisabled) {
        scrollContainer.querySelectorAll('label, input[type="radio"]').forEach(el => {
          el.style.pointerEvents = 'none';
        });
        clicksDisabled = true;
      }
    }

    // Mouse events
    scrollContainer.addEventListener('mousedown', (e) => {
      isScrolling = true;
      startX = e.pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
      initialX = e.pageX;
      startTime = Date.now();
      e.preventDefault();
    });

    scrollContainer.addEventListener('mousemove', (e) => {
      if (!isScrolling) return;
      
      const x = e.pageX - scrollContainer.offsetLeft;
      const distance = x - startX;
      const timeDiff = Date.now() - startTime;
      
      // Only disable clicks if we've moved more than the threshold and within a time window
      if (Math.abs(e.pageX - initialX) > clickThreshold && timeDiff < 300) {
        disableClicks();
      }
      
      scrollContainer.scrollLeft = scrollLeft - distance;
    });

    scrollContainer.addEventListener('mouseup', () => {
      isScrolling = false;
      const timeDiff = Date.now() - startTime;
      
      // Re-enable clicks after a brief delay
      setTimeout(enableClicks, Math.min(50, timeDiff));
    });

    scrollContainer.addEventListener('mouseleave', () => {
      if (isScrolling) {
        isScrolling = false;
        enableClicks();
      }
    });

    // Touch events
    scrollContainer.addEventListener('touchstart', (e) => {
      if (e.touches.length === 1) {
        isScrolling = true;
        startX = e.touches[0].pageX - scrollContainer.offsetLeft;
        scrollLeft = scrollContainer.scrollLeft;
        initialX = e.touches[0].pageX;
        startTime = Date.now();
      }
    }, { passive: true });

    scrollContainer.addEventListener('touchmove', (e) => {
      if (!isScrolling || e.touches.length !== 1) return;
      
      const x = e.touches[0].pageX - scrollContainer.offsetLeft;
      const distance = x - startX;
      const timeDiff = Date.now() - startTime;
      
      // Only disable clicks if we've moved more than the threshold and within a time window
      if (Math.abs(e.touches[0].pageX - initialX) > clickThreshold && timeDiff < 300) {
        disableClicks();
      }
      
      scrollContainer.scrollLeft = scrollLeft - distance;
      startX = x;
      scrollLeft = scrollContainer.scrollLeft;
    }, { passive: true });

    scrollContainer.addEventListener('touchend', () => {
      if (isScrolling) {
        isScrolling = false;
        const timeDiff = Date.now() - startTime;
        
        // Re-enable clicks after a brief delay
        setTimeout(enableClicks, Math.min(50, timeDiff));
      }
    });

    // Ensure clicks are always re-enabled when leaving the container
    scrollContainer.addEventListener('touchcancel', () => {
      if (isScrolling) {
        isScrolling = false;
        enableClicks();
      }
    });
  });
}

// Touch scroll implementation
class TouchScroll {
  constructor(element) {
    this.element = element;
    this.isScrolling = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.clickThreshold = 5; // Pixels of movement before canceling click

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this.init();
  }

  init() {
    // Mouse events
    this.element.addEventListener('mousedown', this.handleMouseDown, { passive: true });
    
    // Touch events
    this.element.addEventListener('touchstart', this.handleTouchStart, { passive: true });
    this.element.addEventListener('touchmove', this.handleTouchMove, { passive: true });
    this.element.addEventListener('touchend', this.handleTouchEnd);
  }

  handleMouseDown(e) {
    this.isScrolling = true;
    this.startX = e.pageX - this.element.offsetLeft;
    this.scrollLeft = this.element.scrollLeft;
    this.initialX = e.pageX;

    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  handleMouseMove(e) {
    if (!this.isScrolling) return;

    const x = e.pageX - this.element.offsetLeft;
    const distance = x - this.startX;
    this.element.scrollLeft = this.scrollLeft - distance;

    // If moved more than threshold, prevent click
    if (Math.abs(e.pageX - this.initialX) > this.clickThreshold) {
      this.element.querySelectorAll('label, input[type="radio"]').forEach(el => {
        el.style.pointerEvents = 'none';
      });
    }
  }

  handleMouseUp() {
    this.isScrolling = false;
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);

    // Re-enable clicks after a short delay
    setTimeout(() => {
      this.element.querySelectorAll('label, input[type="radio"]').forEach(el => {
        el.style.pointerEvents = '';
      });
    }, 10);
  }

  handleTouchStart(e) {
    if (e.touches.length === 1) {
      this.isScrolling = true;
      this.startX = e.touches[0].pageX - this.element.offsetLeft;
      this.scrollLeft = this.element.scrollLeft;
      this.initialX = e.touches[0].pageX;
    }
  }

  handleTouchMove(e) {
    if (!this.isScrolling || e.touches.length !== 1) return;

    const x = e.touches[0].pageX - this.element.offsetLeft;
    const distance = x - this.startX;
    this.element.scrollLeft = this.scrollLeft - distance;

    // If moved more than threshold, prevent click
    if (Math.abs(e.touches[0].pageX - this.initialX) > this.clickThreshold) {
      this.element.querySelectorAll('label, input[type="radio"]').forEach(el => {
        el.style.pointerEvents = 'none';
      });
    }
  }

  handleTouchEnd() {
    this.isScrolling = false;

    // Re-enable clicks after a short delay
    setTimeout(() => {
      this.element.querySelectorAll('label, input[type="radio"]').forEach(el => {
        el.style.pointerEvents = '';
      });
    }, 10);
  }
}

// Initialize touch scroll for all scroll containers
document.addEventListener('DOMContentLoaded', () => {
  const scrollContainers = document.querySelectorAll('.scroll-container, .touch-scroll');
  scrollContainers.forEach(container => new TouchScroll(container));
}); 